<template>
  <div class="flex flex-col items-center lg:items-start bg-white
rounded-4xl sm:rounded-20px py-20 px-40 lg:px-20 lg:py-10 sm:px-5 md:px-4 sm:py-8">
    <h1 v-if="!sended" class="w-full text-44px lg:text-32px font-bold text-neutral-50 sm:hidden">
      {{ $t('landing.candidate-page-title') }}
    </h1>
    <h1 class="w-full text-32px xs:text-2xl  font-bold text-neutral-50 sm:block hidden">
      {{ $t('landing.fill-questionnaire') }}
    </h1>
    <div v-if="!sended" class="w-full xl:w-full flex flex-col space-y-11 mt-8">
<!--      <div class="relative">-->
<!--        <FormInput-->
<!--          v-model.trim="person"-->
<!--          :placeholder="placeholders.person[inputState.person]"-->
<!--          :invalid="$v.person.$error"-->
<!--          @blur="inputBlurHandler('person')"-->
<!--          @focus="inputFocusHandler('person')"-->
<!--        >-->
<!--          <template #label>-->
<!--            <div>{{ $t('landing.type-full-name') }}*</div>-->
<!--          </template>-->
<!--        </FormInput>-->
<!--        <div v-if="$v.person.$error" class="absolute text-danger-50 text-xs left-5 -bottom-5 2xs:-bottom-8">-->
<!--          {{ $t('landing.error:type-full-name') }}-->
<!--        </div>-->
<!--      </div>-->
      <div class="flex space-x-4 xl:space-x-0 xl:flex-col">
        <div class="relative w-1/3 xl:w-full">
          <FormInput
            v-model.trim="lastName"
            :placeholder="placeholders.lastName[inputState.lastName]"
            :invalid="$v.lastName.$error"
            @blur="inputBlurHandler('lastName')"
            @focus="inputFocusHandler('lastName')"
          >
            <template #label>
              <div>{{ $t('landing.type-last-name') }}*</div>
            </template>
          </FormInput>
          <div v-if="$v.lastName.$error" class="absolute text-danger-50 text-xs left-5 -bottom-5 2xs:-bottom-8">
            {{ $t('landing.error:type-last-name') }}
          </div>
        </div>
        <div class="relative w-1/3 xl:w-full xl:mt-9">
          <FormInput
            v-model.trim="firstName"
            :placeholder="placeholders.firstName[inputState.firstName]"
            :invalid="$v.firstName.$error"
            @blur="inputBlurHandler('firstName')"
            @focus="inputFocusHandler('firstName')"
          >
            <template #label>
              <div>{{ $t('landing.type-first-name') }}*</div>
            </template>
          </FormInput>
          <div v-if="$v.firstName.$error" class="absolute text-danger-50 text-xs left-5 -bottom-5 2xs:-bottom-8">
            {{ $t('landing.error:type-first-name') }}
          </div>
        </div>
        <div class="relative w-1/3 xl:w-full xl:mt-9">
          <FormInput
            v-model.trim="patronymicName"
            :placeholder="placeholders.patronymicName[inputState.patronymicName]"
            :invalid="$v.patronymicName.$error"
            @blur="inputBlurHandler('patronymicName')"
            @focus="inputFocusHandler('patronymicName')"
          >
            <template #label>
              <div>{{ $t('landing.type-patronymic-name') }}</div>
            </template>
          </FormInput>
          <div v-if="$v.patronymicName.$error" class="absolute text-danger-50 text-xs left-5 -bottom-5 2xs:-bottom-8">
            {{ $t('landing.error:type-patronymic-name') }}
          </div>
        </div>
      </div>
      <div class="flex sm:flex-col sm:space-y-9 space-x-4 sm:space-x-0">
        <div class="relative w-1/2 sm:w-full">
          <FormSelect
            v-model="nationality"
            :options="nationalityOptions"
            :placeholder="`${$t('landing.citizenship')}*`"
            :invalid="$v.nationality.$error"
            @search-blur="checkData('nationality')"
          >
            <template #label>
              <div>{{ $t('landing.citizenship') }}*</div>
            </template>
          </FormSelect>
          <div v-if="$v.nationality.$error" class="absolute text-danger-50 text-xs left-5 -bottom-5">
            {{ $t('landing.error:citizenship') }}
          </div>
        </div>
        <div class="relative w-1/2 sm:w-full">
          <FormInputDate
            v-model="birthday"
            class="date-picker"
            :invalid="$v.birthday.$error"
            :max-date="maxDate"
            @blur="checkData('birthday')"
          >
            <template #label>
              <div>{{ $t('landing.birthday') }}*</div>
            </template>
          </FormInputDate>
          <div v-if="$v.birthday.$error" class="absolute text-danger-50 text-xs left-5 -bottom-5">
            {{ $t('landing.error:birthday') }}
          </div>
        </div>
      </div>
      <div class="flex xl:flex-col sm:space-y-9 gap-4 xl:gap-8">
        <div class="flex gap-4 relative w-1/2 xl:w-full">
          <FormSelect
            v-model="phoneCode"
            class="w-24"
            :options="phoneCodes"
          >
            <template #label>
              <div>{{ $t('landing.code') }}*</div>
            </template>
          </FormSelect>
          <div class="w-full relative">
            <FormInput
              v-model="phone"
              class="w-full"
              ref="phoneInput"
              :invalid="$v.phone.$error"
              :mask="getPhoneMaskWithoutCode(phoneCode)"
              :placeholder="`${$t('landing.phone-number')}*`"
              :key="phoneCode"
              :isStatic="!phoneCode"
              @blur="checkData('phone')"
              @paste="phone = $event.clipboardData.getData('text')"
            >
              <template #label>
                <div>{{ $t('landing.phone-number') }}*</div>
              </template>
            </FormInput>
            <div v-if="$v.phone.$error" class="absolute text-danger-50 text-xs left-5 -bottom-5">
              {{ $t('landing.error:phone') }}
            </div>
          </div>
        </div>
        <div class="relative w-1/2 xl:w-full">
          <FormInput
            v-model="email"
            :invalid="$v.email.$error"
            :placeholder="`${$t('landing.email')}*`"
            @blur="checkData('email')"
          >
            <template #label>
              <div>{{ $t('landing.email') }}*</div>
            </template>
          </FormInput>
          <div v-if="$v.email.$error" class="absolute text-danger-50 text-xs left-5 -bottom-5">
            {{ $t('landing.error:correct-email') }}
          </div>
        </div>
      </div>
      <div class="relative w-full">
        <FormSelect
          v-model="communicationMethod"
          :options="communicationMethodOptions"
          :invalid="$v.communicationMethod.$error"
          :placeholder="`${$t('landing.prefered-communication-method')}*`"
          @search-blur="checkData('communicationMethod')"
        >
          <template #label>
            <div>{{ $t('landing.prefered-communication-method') }}*</div>
          </template>
        </FormSelect>
        <div v-if="$v.communicationMethod.$error" class="absolute text-danger-50 text-xs left-5 -bottom-5">
          {{ $t('landing.error:prefered-communication-method') }}
        </div>
      </div>
      <div v-show="communicationMethod === 'VK'" class="relative w-full">
        <FormInput
          v-model="profile"
          :invalid="$v.profile.$error"
          :placeholder="`${$t('landing.type-profile-vk-link')}*`"
          @blur="checkData('profile')"
        >
          <template #label>
            <div>{{ $t('landing.profile-vk') }}*</div>
          </template>
        </FormInput>
      </div>
      <div class="flex lg:flex-col lg:space-y-11 sm:space-y-9 space-x-4 lg:space-x-0">
        <div class="relative w-1/2 lg:w-full">
          <FormSelect
            v-model="schedule"
            :options="schedulesOptions"
            :invalid="$v.schedule.$error"
            :placeholder="`${$t('landing.prefered-schedule')}*`"
            @search-blur="checkData('schedule')"
          >
            <template #label>
              <div>{{ $t('landing.prefered-schedule') }}*</div>
            </template>
          </FormSelect>
          <div v-if="$v.schedule.$error" class="absolute text-danger-50 text-xs left-5 -bottom-5">
            {{ $t('landing.error:prefered-schedule') }}
          </div>
        </div>
        <div class="relative w-1/2 lg:w-full">
          <FormInput
            v-model="profit"
            :invalid="$v.profit.$error"
            :placeholder="`${$t('landing.expected-income-level')}*`"
            @blur="checkData('profit')"
          >
            <template #label>
              <div>{{ $t('landing.expected-income-level') }}*</div>
            </template>
          </FormInput>
          <div v-if="$v.profit.$error" class="absolute text-danger-50 text-xs left-5 -bottom-5">
            {{ $t('landing.error:expected-income-level') }}
          </div>
        </div>
      </div>
      <div>
        <FormFile
          v-show="!resume"
          v-model="resume"
          :accept="[
          'application/msword',
          'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
          'application/vnd.ms-excel',
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          'application/pdf',
          'application/vnd.oasis.opendocument.text',
          'application/vnd.oasis.opendocument.spreadsheet',
          'image/jpeg',
          'image/png',
          'image/gif',
        ]"
          @input="fileInputHandler"
        />
        <div
          v-if="!!resume"
          class="flex justify-between"
        >
          <div class="flex space-x-2">
            <img src="@/assets/icons/file.svg" alt="" />
            <span>{{resume[0].name}}</span>
          </div>
          <img
            src="@/assets/icons/cancel.svg"
            alt=""
            class="block cursor-pointer"
            @click="resume = null"
          />
        </div>
      </div>
      <div class="flex space-x-2">
        <FormCheckbox
          v-model="agree"
          :invalid="shouldAgreementVideo"
          @input="($event) => shouldAgreementVideo = !$event"
        />
        <p :class="{ 'text-danger-50': shouldAgreementVideo }">
          {{ $t('landing.online-stage-video-recording-agreement') }}
        </p>
      </div>
      <div class="flex space-x-2 items-start">
        <FormCheckbox
          v-model="agreement"
          :invalid="shouldAgreement"
          @input="($event) => shouldAgreement = !$event"
        />
        <p
          v-if="$domain === 'uz' && $route.query.language === 'ru'"
          class="text-left text-base sm:text-sm"
          :class="{ 'text-danger-50': shouldAgreement }"
          v-html="$t('landing.data-processing-and-agreement-links-uz')"
        ></p>
        <p
          v-else
          class="text-left text-base sm:text-sm"
          :class="{ 'text-danger-50': shouldAgreement }"
          v-html="$t('landing.data-processing-and-agreement-links')"
        ></p>
      </div>
      <div class="flex sm:flex-col justify-end sm:space-y-4 space-x-4 sm:space-x-0">
        <Button
          class="w-1/2 sm:w-full"
          :disabled="isSendButtonDisabled || isSlowUpload"
          @click="onSubmit"
        >
          <template v-if="!isSlowUpload">{{ $t('landing.send-questionnaire') }}</template>
          <Spinner v-else />
        </Button>
      </div>
      <p class="text-center text-neutral-150 text-sm">
        {{ $t('landing.online-stage-personal-link-email')}}.
      </p>
    </div>
    <div v-if="sended" class="max-w-md flex flex-col items-center space-y-5">
      <img src="@/assets/icons/ok-icon.svg" alt="ok">
      <h1 class="text-32px font-bold">
        {{ $t('landing.questionnaire-sent-successfully') }}
      </h1>
      <p
        class="last-screen-text"
        v-html="$t('landing.online-stage-personal-link-sent-on-your-email', { userEmail: email })"
      ></p>
      <template v-if="$domain === 'ru'">
        <p
          v-if="telegramLink" class="last-screen-text"
          v-html="$t('landing.link-our-telegram-for-more-info')"
        ></p>

        <p v-else class="last-screen-text">
          {{ $t('landing.generating-telegram-link-please-wait') }}
        </p>
        <a
          v-if="telegramLink"
          :href="telegramLink"
          class="flex items-center justify-center w-full h-12 rounded-10px
       bg-neutral-200 text-primary-400 space-x-2 last-screen-text"
          target="_blank"
        >
          <img src="@/assets/icons/telegram_blue.svg" alt="">
          <span>{{ $t('landing.go-to-telegram') }}</span>
        </a>
      </template>
    </div>
  </div>
</template>

<script>
import debounce from 'lodash.debounce';
import {
  required,
  minLength,
  email,
  maxLength,
} from 'vuelidate/lib/validators';
import { i18n } from '@/i18n';
import FormInput from '@/components/Form/FormInput.vue';
import FormSelect from '@/components/Form/FormSelect.vue';
import FormInputDate from '@/components/Form/FormInputDate.vue';
import FormCheckbox from '@/components/Form/FormCheckbox.vue';
import FormFile from '@/components/Form/FormFile.vue';
import Button from '@/components/UI/Button.vue';
import Spinner from '@/components/Bars/Spinner.vue';
import toast from '@/notify';
import sanitize from '@/sanitize';
import {
  http,
  getVacancies,
  getWorkSchedules,
  postCandidate,
  updateCandidateData,
  getVacancy,
  getOffices,
  getCountries,
  getCandidateRegions,
  updateCandidateDetail,
  postResume,
  checkDuplicates,
  aplicationConfirm,
  getTelegramLink,
} from '@/api';
import phoneMaskMixin from '@/mixins/phoneMaskMixin';
import { phoneValidator } from '@/helpers/validation';
import { phoneCodes } from '@/constants/countryList';

export default {
  name: 'VacancyContent',
  components: {
    Spinner,
    FormInput,
    FormSelect,
    FormInputDate,
    FormCheckbox,
    FormFile,
    Button,
  },
  mixins: [phoneMaskMixin],
  data() {
    return {
      phoneCodes,
      phoneCode: '',
      i18n,
      sended: false,
      nationalityData: [],
      vacanciesData: [],
      officesData: [],
      schedulesData: [],
      regionsData: [],
      telegramLink: null,
      preferredCommunicationMap: new Map([
        [this.$t('landing.phone'), 'PHONE'],
        [this.$t('landing.email'), 'EMAIL'],
        ['Telegram', 'TELEGRAM'],
        ['WhatsApp', 'WA'],
        ['Viber', 'VIBER'],
        ['VK', 'VK'],
      ]),
      // person: '',
      firstName: '',
      lastName: '',
      patronymicName: '',
      nationality: '',
      birthday: new Date('2000-06-01'),
      phone: '',
      email: '',
      agreement: false,
      shouldAgreement: false,
      profile: '',
      communicationMethod: this.$t('landing.phone'),
      communicationMethodOptions: [
        this.$t('landing.phone'),
        this.$t('landing.email'),
        'Telegram',
        'WhatsApp',
        'Viber',
        'VK',
      ],
      vacancy: '',
      city: '',
      cityId: '',
      shop: '',
      schedule: '',
      profit: '',
      departments: [],
      goSports: true,
      healthyLifestyle: true,
      kindsOfSport: '',
      resume: null,
      agree: false,
      shouldAgreementVideo: false,
      radioOptions: [
        { label: this.$t('common.yes'), checked: true },
        { label: this.$t('common.no'), checked: false },
      ],
      placeholders: {
        // person: {
        //   focus: this.$t('landing.full-name-exemplicant'),
        //   blur: `${this.$t('landing.type-full-name')}*`,
        // },
        firstName: {
          focus: this.$t('landing.first-name-exemplicant'),
          blur: `${this.$t('landing.type-first-name')}*`,
        },
        lastName: {
          focus: this.$t('landing.last-name-exemplicant'),
          blur: `${this.$t('landing.type-last-name')}*`,
        },
        patronymicName: {
          focus: this.$t('landing.patronymic-name-exemplicant'),
          blur: `${this.$t('landing.type-patronymic-name')}`,
        },
      },
      inputState: {
        // person: 'blur',
        firstName: 'blur',
        lastName: 'blur',
        patronymicName: 'blur',
      },
      isSendButtonDisabled: false,
      isSlowUpload: false,
    };
  },
  validations() {
    return {
      // person: {
      //   required,
      //   mustBeRussianStrings: (value) => {
      //     switch (this.$i18n.locale) {
      //       case 'ru': return /^[а-яё\s]{1,}(-)?[а-яё\s]{1,} [а-яё\s]{1,} [а-яё\s]{1,}$/i.test(value);
      //       default: return true;
      //     }
      //   },
      //   mustHaveThreeWords: (value) => value.split(' ').length === 3,
      //   symbolsTest: (value) => !/[\\|/'"`]/g.test(value),
      // },
      lastName: {
        required,
        mustBeRussian: (value) => {
          if (!value) return true;
          switch (this.$i18n.locale) {
            case 'ru':
              return /^[а-яё-]+$/i.test(value.trim());
            default:
              return true;
          }
        },
        symbolsTest: (value) => !/[\\|/'"`]/g.test(value),
      },
      firstName: {
        required,
        mustBeRussian: (value) => {
          if (!value) return true;
          switch (this.$i18n.locale) {
            case 'ru':
              return /^[а-яё-]+$/i.test(value.trim());
            default:
              return true;
          }
        },
        symbolsTest: (value) => !/[\\|/'"`]/g.test(value),
      },
      patronymicName: {
        mustBeRussian: (value) => {
          if (!value) return true;
          switch (this.$i18n.locale) {
            case 'ru':
              return /^[а-яё-]+$/i.test(value.trim());
            default:
              return true;
          }
        },
        symbolsTest: (value) => !/[\\|/'"`]/g.test(value),
      },
      profile: {
        shouldHaveValueIfCurrent: (value, v) => (v.communicationMethod === 'VK' ? !!value : true),
      },
      nationality: {
        required,
      },
      birthday: {
        required,
        belowMaxDate: (value) => {
          const currentDate = new Date();
          const currentYear = currentDate.getFullYear();
          const maxYear = currentYear - 1;
          const maxDate = currentDate.setFullYear(maxYear, 11, 31);
          return new Date(value) <= new Date(maxDate);
        },
      },
      phone: phoneValidator(this.phoneCode),
      email: {
        required,
        email,
        symbolsTest: (value) => !/[\\|/'"`]/g.test(value),
      },
      communicationMethod: {
        required,
      },
      schedule: {
        required,
      },
      profit: {
        required,
        minLength: minLength(2),
        maxLength: maxLength(80),
        symbolsTest: (value) => !/[\\|/'"`]/g.test(value),
      },
    };
  },
  async mounted() {
    const queue1 = [
      getCountries(),
      getWorkSchedules(),
    ];

    const { segment } = this.$route.query;

    const queue2 = [
      getCandidateRegions(segment),
      getOffices(segment),
      getVacancies(segment),
    ];

    const setDataMap = new Map([
      ['/countries', 'nationalityData'],
      ['/regions', 'regionsData'],
      ['/offices-candidate', 'officesData'],
      ['/vacancies-candidate/positions', 'vacanciesData'],
      ['/work-schedules', 'schedulesData'],
    ]);

    await Promise.all(queue1).then((response) => {
      Array.from(response).forEach(({ config, data }) => {
        if (!data?.error) {
          this[setDataMap.get(config.url)] = data;
        }
        this[setDataMap.get(config.url)] = data;
      });
    });

    await Promise.all(queue2).then((response) => {
      Array.from(response).forEach(({ config, data }) => {
        if (!data?.error) {
          this[setDataMap.get(config.url)] = data.data || data;
        }
      });
    });
    const { position, office } = this.$route.query;
    if (position) {
      const { status, data } = await getVacancy({ position, office });
      if (status === 200) {
        this.vacancy = data?.vacancy?.name;
        this.shop = data?.office?.name;
        if (office) {
          const currentOffice = this.officesData?.find(({ id }) => id === office);
          const currentRegion = this.regionsFormattedOptions.find(({ ids }) => ids.includes(currentOffice.cityId));
          this.city = currentRegion.key;
        }
      }
    }

    const storageData = JSON.parse(sessionStorage.getItem('userInfo'));
    if (storageData) {
      // this.person = storageData.person;
      this.firstName = storageData.firstName;
      this.lastName = storageData.lastName;
      this.patronymicName = storageData.patronymicName;
      this.nationality = storageData.nationality;
      this.birthday = new Date(storageData.birthday);
      this.email = storageData.email;
      this.agreement = storageData.agreement;
      this.communicationMethod = storageData.communicationMethod;
    }
    if (storageData?.phone) {
      const [phoneCode] = storageData.phone.match(/\+(.*?) /);
      this.phoneCode = phoneCode.trim();
      this.phone = storageData.phone.replace(phoneCode);
    }
    const storageVacancyData = JSON.parse(sessionStorage.getItem('vacancyInfo'));
    if (storageVacancyData) {
      this.vacancy = storageVacancyData.vacancy;
      this.city = storageVacancyData.city;
      this.cityId = storageVacancyData.cityId;
      this.shop = storageVacancyData.shop;
      this.schedule = storageVacancyData.schedule;
      this.profit = storageVacancyData.profit;
    }

    const storageQuestionData = JSON.parse(sessionStorage.getItem('questionInfo'));

    if (storageQuestionData) {
      this.goSports = storageQuestionData.goSports;
      this.kindsOfSport = storageQuestionData.kindsOfSport;
      this.resume = storageQuestionData.resume;
      this.agree = storageQuestionData.agree;
    }
  },
  computed: {
    maxDate() {
      const currentDate = new Date();
      const currentYear = currentDate.getFullYear();
      const maxYear = currentYear - 1;
      const maxDate = currentDate.setFullYear(maxYear, 11, 31);
      return new Date(maxDate);
    },
    nationalityOptions() {
      return this.nationalityData.map(({ name }) => name);
    },
    schedulesOptions() {
      return this.schedulesData.map(({ name }) => name);
    },
    regionsFormattedOptions() {
      const cityNames = this.regionsData.map(({ name }) => name);
      const uniqCityNames = Array.from(new Set(cityNames));

      return uniqCityNames.map((city) => {
        const ids = this.regionsData
          .filter(({ name }) => name === city)
          .map(({ id }) => id);
        return { key: city, label: city, ids };
      });
    },
  },
  methods: {
    /* eslint-disable */
    debouncedSubmit: debounce(
      function () {
        this.submitUserInfo();
      },
      1000,
    ),
    /* eslint-enable */
    async onSubmit() {
      this.isSendButtonDisabled = true;
      const { name: routeName, query } = this.$route;
      const { brand, segment } = query;
      this.$v.$touch();
      if (!this.agree) {
        this.shouldAgreementVideo = true;
      }
      if (!this.agreement) {
        this.shouldAgreement = true;
      }
      if (this.$v.$invalid) {
        this.isSendButtonDisabled = false;
      } else if (!this.agree || !this.agreement) {
        this.isSendButtonDisabled = false;
      }
      if (!this.$v.$invalid && this.agreement && this.agree) {
        const userInfo = {
          // person: sanitize(this.person),
          firstName: sanitize(this.firstName),
          lastName: sanitize(this.lastName),
          patronymicName: sanitize(this.patronymicName),
          nationality: this.nationality,
          birthday: this.birthday,
          phone: `${this.phoneCode} ${this.phone}`,
          email: this.email,
          agreement: this.agreement,
          communicationMethod: this.communicationMethod,
          profile: this.profile,
        };

        let candidateToken = JSON.parse(sessionStorage.getItem('candidateToken'));

        const dataToPost = {
          brand,
          segment,
          // fullName: sanitize(userInfo.person),
          firstName: sanitize(this.firstName),
          lastName: sanitize(this.lastName),
          patronymicName: sanitize(this.patronymicName),
          citizenship: sanitize(userInfo.nationality),
          birthday: userInfo.birthday,
          email: sanitize(userInfo.email),
          phone: sanitize(userInfo.phone.replace(/[+\s()-]/g, '')),
          consentData: userInfo.agreement,
          preferredCommunication: sanitize(this.preferredCommunicationMap.get(userInfo.communicationMethod)),
          socials: userInfo.communicationMethod === 'VK' ? [{ type: 'VK', urn: userInfo.profile }] : [],
        };

        if (candidateToken) {
          await updateCandidateData(candidateToken.candidateId, dataToPost, candidateToken.token);
          sessionStorage.setItem('userInfo', JSON.stringify(userInfo));
        } else {
          setTimeout(() => {
            this.isSlowUpload = true;
          }, 1000);
          await postCandidate(dataToPost)
            .then(({ data }) => {
              if (data) {
                sessionStorage.setItem('userInfo', JSON.stringify(userInfo));
                candidateToken = data;
                sessionStorage.setItem('candidateToken', JSON.stringify(data));

                const token = data.token || '';

                http.defaults.headers['X-Authorization'] = token;
                http.defaults.headers['X-Authorization-Candidate'] = token;
              }
            });
        }

        const vacancyInfo = {
          vacancy: this.vacancy,
          city: this.city,
          cityId: this.shop
            ? sanitize(this.officesData.find(({ name }) => name === this.shop).cityId)
            : this.departments[0],
          shop: this.shop,
          schedule: this.schedule,
          profit: sanitize(this.profit),
        };
        sessionStorage.setItem('vacancyInfo', JSON.stringify(vacancyInfo));

        if (!this.agree) {
          this.shouldAgreementVideo = true;
          return;
        }

        if (!this.agreement) {
          this.shouldAgreement = true;
          return;
        }
        const questionInfo = {
          goSports: this.goSports,
          healthyLifestyle: this.healthyLifestyle,
          kindsOfSport: sanitize(this.kindsOfSport),
          resume: this.resume,
          agree: this.agree,
        };
        // eslint-disable-next-line
        window.ym(91187058, 'reachGoal', 'send_form_candidate');

        sessionStorage.setItem('questionInfo', JSON.stringify(questionInfo));

        const currentVacancyId = routeName.toLowerCase() === 'vacancy'
          ? query.position
          : this.vacanciesData.find(({ name }) => name === vacancyInfo.vacancy)?.id;
        const currentOffice = this.officesData.find(({ name }) => name === vacancyInfo.shop);
        const { resume } = questionInfo;
        const source = query?.utm_source;

        const candidateInDetails = {
          brand: query.brand && query.brand.toLowerCase() === 'franchise' ? 'FRANCHISE' : 'SPORTMASTER',
          city: sanitize(vacancyInfo.cityId),
          consentVideo: questionInfo.agree,
          favoriteSport: questionInfo.kindsOfSport ? sanitize(questionInfo.kindsOfSport) : null,
          healthyLifestyle: questionInfo.healthyLifestyle,
          income: sanitize(vacancyInfo.profit),
          storeAddress: sanitize(currentOffice?.id),
          takeExercise: questionInfo.goSports,
          vacancy: currentVacancyId,
          workSchedule: sanitize(vacancyInfo.schedule),
          source: source || 'landing',
        };

        if (candidateToken) {
          await updateCandidateDetail(candidateToken.applicationId, candidateInDetails, candidateToken.token);
          if (resume) {
            const resumeData = new FormData();
            resumeData.append('file', resume[0]);
            try {
              await postResume(candidateToken.applicationId, resumeData, candidateToken.token);
            } catch {
              console.log('error');
            }
          }
          await checkDuplicates(candidateToken.applicationId, candidateToken.token)
            .then(async ({ status }) => {
              if (status === 200) {
                await aplicationConfirm(candidateToken.applicationId, candidateToken.token);
                if (this.$domain === 'ru') {
                  try {
                    const result = await getTelegramLink(candidateToken?.applicationId, candidateToken?.token);
                    const { status: telegramRequestStatus, data: { telegramLink } } = result;
                    if (telegramRequestStatus === 200) {
                      this.telegramLink = telegramLink;
                    }
                  } catch {
                    toast.danger({
                      title: 'Не удалось получить ссылку ан телеграмм',
                    });
                  }
                }
                this.currentStep = 4;
              } else if (status === 409) {
                await aplicationConfirm(candidateToken.applicationId, candidateToken.token);
                if (this.$domain === 'ru') {
                  let callCount = 0;
                  const intervalId = setInterval(async () => {
                    try {
                      const result = await getTelegramLink(candidateToken?.applicationId);
                      const { status: telegramRequestStatus, data: { telegramLink, candidateId } } = result;
                      if (telegramRequestStatus === 200 && candidateId !== candidateToken.candidateId) {
                        this.telegramLink = telegramLink;
                      }
                    } catch {
                      toast.danger({
                        title: 'Не удалось получить ссылку на телеграмм',
                      });
                    }
                    callCount += 1;
                    if (callCount >= 5) {
                      clearInterval(intervalId);
                    }
                  }, 3000);
                }
                this.currentStep = 4;
                sessionStorage.removeItem('candidateToken');
              }
            })
            .catch(() => {
              toast.danger({
                title: this.$t('errors.service-is-unavailable'),
              });
            });
          this.isSlowUpload = false;
          this.isSendButtonDisabled = false;
          this.sended = true;
        }
      }
    },
    async getTgLink(candidateToken) {
      try {
        const result = await getTelegramLink(candidateToken?.applicationId, candidateToken?.token);
        const { status: telegramRequestStatus, data: { telegramLink } } = result;
        if (telegramRequestStatus === 200) {
          this.telegramLink = telegramLink;
        }
      } catch {
        toast.danger({
          title: this.$t('errors.cannot-get-telegram-link'),
        });
      }
    },
    checkData(d) {
      this.$v[d].$touch();
      if (d === 'email') {
        const regexp = /^(?:[^:]+:\/\/)?([^.]+\.)*([^.]+)\.([^.]+)(?:$|\/)/;
        const domain = this.email.match(regexp);
        if (!['ru', 'com'].includes(domain[3])) {
          toast.warning({
            title: this.$t('errors.maybe-error'),
            text: this.$t('errors.check-email'),
          });
        }
      }
    },
    inputFocusHandler(d) {
      this.inputState[d] = 'focus';
    },
    inputBlurHandler(d) {
      this.inputState[d] = 'blur';
      this.checkData(d);
    },
    fileInputHandler(e) {
      console.log(e);
    },
  },
  watch: {
    phoneCode() {
      this.phone = '';
    },
  },
};
</script>

<style lang="scss">

</style>
